import Vue from 'vue'

export const findCommandListByPage = params => {
  return Vue.fetch.post('/apiv1/hr/command/findCommandListByPage', params)
}

// 批量重发设备命令
export const resendCommandByCmdIds = params => {
  return Vue.fetch.post('/apiv1/hr/command/resendCommandByCmdIds', params)
}

export const resendCommandByCmdId = params => {
  return Vue.fetch.post('/apiv1/hr/command/resendCommandByCmdId', params)
}



// WEBPACK FOOTER //
// ./src/services/commandApi.js